export class QualitySpecification {
    constructor({
          id = null,
          code= '', 
          name= ``, 
          upLimit= ``,
          lowLimit= ``, 
          unit='',     
      } = {}) {
      this.id = id;
      this.code = code;
      this.name = name;
      this.upLimit = upLimit;
      this.lowLimit = lowLimit;    
      this.unit=unit;
    }
  }
  export function gridFields() {
    return Object.freeze([ 
        {
            key: 'code',
            label: 'lbl.qualitySpecification.code',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
          key: 'name',
          label: 'lbl.qualitySpecification.name',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'upLimit',
          label: 'lbl.qualitySpecification.upLimit',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'lowLimit',
          label: 'lbl.qualitySpecification.lowLimit',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'unit',
          label: 'lbl.qualitySpecification.unit',
          sortable: false,
          form: {
            type: 'input'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new QualitySpecification()).map(i => 'entity.' + i));

  export const filterFields = [
    'filter.codeFilter',
    'filter.nameFilter'
  ];
  export const filter = {
    'codeFilter': "",
    'nameFilter': ""    
  };